import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import SearchBar from '../../general/SearchBar.js';

export const ReservationsTable = ({
  title = "Schedule for Check Out",
  searchValue,
  onSearchChange,
  searchPlaceholder = "Search check-outs",
  rows,
  columns,
  getRowId,
  onRowClick,
  rowHeight = 80,
  height = 580,
}) => {
  return (
    <div className="checkout-table-container">
      <div className="table-titles">
        {/* <h2>{title}</h2> */}
      </div>
      <div className='search-container'>
        <h2 style={{margin:'10px'}}>{title}</h2>
        <SearchBar 
          value={searchValue}
          onChange={onSearchChange}
          label={searchPlaceholder}
          width="300px"
          justifyContent="flex-end"
          marginTop="0px"
          marginBottom="0px"
          marginLeft="0px"
          marginRight="0px"
          fullWidth={false}
        />
      </div>
      <div className="dataGridContainer" style={{ height, width: "100%" }}>
        <DataGrid
          rows={rows}
          columns={columns}
          getRowId={getRowId}
          disableSelectionOnClick
          rowHeight={rowHeight}
          onRowClick={onRowClick}
        />
      </div>
    </div>
  );
};

